import {
    Button,
    Classes,
    Dialog,
    FormGroup,
    InputGroup,
} from '@blueprintjs/core'
import React from 'react'
import { connect } from 'react-redux'
import * as supplierModules from 'src/store/modules/cmdb/suppliers'

export const getContactData = (contact) => {
    return {
        id: (contact && contact.id) || null,
        name: (contact && contact.name) || '',
        role: (contact && contact.role) || '',
        email: (contact && contact.email) || '',
        phone: (contact && contact.phone) || '',
    }
}

export const errorForField = (errors, field) =>
    errors[field] && errors[field].join(', ')

class ContactDialog extends React.Component {
    state = {
        ...getContactData({ name: this.props.name }),
    }

    handleFieldChange = (field) => (e) =>
        this.setState({ [field]: e.target.value })

    handleContactSave = () => {
        const { name, role, email, phone, id } = this.state
        const {
            isChangingOwner,
            openAction,
            activeRunbook,
            saveSupplier,
        } = this.props
        const data = {
            name,
            role,
            email,
            phone: phone.replace(/\s/g, ''),
        }

        if (isChangingOwner) {
            saveSupplier(id, data, activeRunbook, openAction)
        } else {
            saveSupplier(id, data)
        }
    }

    render() {
        const { id, name, role, email, phone } = this.state
        const { errors, closeModal } = this.props
        return (
            <Dialog
                isOpen={true}
                onClose={closeModal}
                title={(id && 'Edit Contact') || 'New Contact'}
            >
                <div className={Classes.DIALOG_BODY}>
                    <FormGroup
                        label="Name"
                        labelFor="name"
                        helperText={errorForField(errors, 'name')}
                        intent={errorForField(errors, 'name') && 'danger'}
                    >
                        <InputGroup
                            id="name"
                            value={name}
                            placeholder="Jimi Hendrix"
                            intent={errorForField(errors, 'name') && 'danger'}
                            onChange={this.handleFieldChange('name')}
                            fill
                            large
                        />
                    </FormGroup>
                    <FormGroup
                        label="Role"
                        labelFor="role"
                        helperText={errorForField(errors, 'role')}
                        intent={errorForField(errors, 'role') && 'danger'}
                    >
                        <InputGroup
                            id={role}
                            value={role}
                            placeholder="Electric Co. Regional Contact"
                            intent={errorForField(errors, 'role') && 'danger'}
                            onChange={this.handleFieldChange('role')}
                            fill
                            large
                        />
                    </FormGroup>
                    <FormGroup
                        label="Email"
                        labelFor="email"
                        helperText={errorForField(errors, 'email')}
                        intent={errorForField(errors, 'email') && 'danger'}
                    >
                        <InputGroup
                            id="email"
                            value={email}
                            placeholder="someone@example.com"
                            intent={errorForField(errors, 'email') && 'danger'}
                            onChange={this.handleFieldChange('email')}
                            fill
                            large
                        />
                    </FormGroup>
                    <FormGroup
                        label="Phone"
                        labelFor="phone"
                        helperText={errorForField(errors, 'phone')}
                        intent={errorForField(errors, 'phone') && 'danger'}
                    >
                        <InputGroup
                            id="phone"
                            value={phone}
                            placeholder="+32474123456"
                            intent={errorForField(errors, 'phone') && 'danger'}
                            onChange={this.handleFieldChange('phone')}
                            fill
                            large
                        />
                    </FormGroup>
                </div>
                <div className={Classes.DIALOG_FOOTER}>
                    <Button
                        intent="primary"
                        large
                        onClick={this.handleContactSave}
                    >
                        Save
                    </Button>
                    <Button intent="lynch-underline" large onClick={closeModal}>
                        Cancel
                    </Button>
                </div>
            </Dialog>
        )
    }
}

const mapStateToProps = (state) => {
    return {
        isChangingOwner: state.ui.runbook.controls.isChangingOwner,
        openAction: state.ui.runbook.controls.singleOpenAction,
        activeRunbook: state.ui.runbook.activeRunbook,
        errors: state.cmdb.suppliers.errors,
    }
}

export default connect(mapStateToProps, {
    saveSupplier: supplierModules.saveSupplier,
    closeModal: supplierModules.closeSupplier,
})(ContactDialog)
